import classNames from "classnames";

// Mirrors Figma "Badge / Size=sm, Type=Pill color, Icon=Dot" component.
// color must be one of the keys defined in tokens.scss $badge-colors.
const Badge = ({ label, color = "gray", className }) => (
  <span className={classNames("ea-badge", `ea-badge--${color}`, className)}>
    <span className="ea-badge__dot" aria-hidden="true" />
    {label}
  </span>
);

export default Badge;
